//User
export const SET_USER = "user/fetch";
export const SET_USER_ERROR = "user/error";
export const SET_USER_LOADING = "user/loading";

//Kenshi
export const SET_KENSHI = "kenshi/fetch";
export const SET_KENSHI_ERROR = "kenshi/error";
export const SET_KENSHI_LOADING = "kenshi/loading";

//Video
export const SET_VIDEO = "video/fetch";
export const SET_MY_VIDEO = "myVideo/fetch";
export const SET_VIDEO_ERROR = "video/error";
export const SET_VIDEO_LOADING = "video/loading";

//Dojo
export const SET_DOJO = "dojo/fetch";
export const SET_DOJO_ERROR = "dojo/error";
export const SET_DOJO_LOADING = "dojo/loading";